import React from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext } from 'components/Managers/Billing/Context';

import List from './List';
import NoPaymentMethods from './NoPaymentMethods';

import BillingManagerView from './BillingManager/Wrapper';
import BillingManagerInformationView from '../BillingInformation/Index';

export default function Index() {
  const { state } = useContext();

  if (state.paymentMethods == null) {
    return <section><LoadingPlaceholder text="Loading..." className="my-4" /></section>;
  }

  return (
    <>
      {state.paymentMethods.length <= 1 ? (
        <>
          <section>
            <BillingManagerView paymentMethod={state.paymentMethods.length > 0 ? state.paymentMethods[0] : null} />
          </section>
          <section>
            <BillingManagerInformationView
              paymentMethod={state.paymentMethods.length > 0 ? state.paymentMethods[0] : null}
            />
          </section>
        </>
      ) : (
        <section>
          <h4 className="mb-4">Billing Information</h4>
          <div>
            {state.paymentMethods.length === 0
              ? <NoPaymentMethods />
              : <List paymentMethods={state.paymentMethods} /> }

          </div>
        </section>
      )}
    </>
  );
}
